import React from 'react';
import { withRouter } from 'react-router-dom';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import EditVouchersForm from '../../components/Voucher/EditVouchersForm';
import withAuthorization from '../../hoc/withAuthorization';

const EditVouchersPage = props =>
  <LargePaper>
    <h1 style={stylesDefault.title}>Editer un coupon</h1>
    <EditVouchersForm history={props.history} match={props.match}/>
  </LargePaper>;

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(withRouter(EditVouchersPage));



// WEBPACK FOOTER //
// ./src/containers/VouchersPage/EditVouchersPage.jsx